<template>
    <div>
        <div v-if="!showMap">
            <AgentCompanyFinderAndCreator
                :key="componentRefreshKey"
                :isNeedCreate="false"
                :changed-item="changedItem"
                :additionalGetParameter="additionalGetParameter"
                :typeOfTableFilter="$route.params.invoice_type ? '' : 'agentCompanies'"
                @onMap="onMap"
            />
        </div>
        
        <div v-else>
            <div class="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h3>Карта агентских компаний</h3>
                    <p class="mb-0 text-muted">Отображение всех агентских компаний по регионам России</p>
                </div>
                <b-button variant="outline-secondary" @click="backToTable">
                    <i class="fas fa-arrow-left mr-2"></i>
                    Вернуться к таблице
                </b-button>
            </div>
            <AgentsOnMap />

            <div class="mt-4">
                <DailyAgentStats />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AgentCompanyFinderAndCreator from '@/components/agentCompanies/AgentCompanyFinderAndCreator.vue'
    import AgentsOnMap from '@/components/agentCompanies/AgentsOnMap.vue'
    import DailyAgentStats from '@/components/dashboards/DailyAgentStats.vue'

    export default {
        components: {
            AgentCompanyFinderAndCreator,
            AgentsOnMap,
            DailyAgentStats,
        },
        props: {
            changedItem: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                additionalGetParameter: '',
                componentRefreshKey: 0,
                showMap: false,
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),
        },
        created() {
            this.additionalGetParameterChanger()
        },
        watch: {
            '$route.path'() {
                this.additionalGetParameterChanger()
            }
        },
        methods: {
            additionalGetParameterChanger() {
                if (this.$route.params.invoice_type) {
                    this.additionalGetParameter = `&invoice_type=${this.$route.params.invoice_type}`
                } else {
                    this.additionalGetParameter = ''
                }
                this.componentRefreshKey += 1
            },
            onMap() {
                this.showMap = true
            },
            backToTable() {
                this.showMap = false
            }
        }
    }
</script>
